import _ from 'lodash';

export default {
    data: function () {
        return {
            service: '',
            reloadBus: null,
            afterLoad: null,
            defaultFilterFormModel: {
                page: 1,
                pageSize: 50
            },
            autoLoad: true,
            reloadInterval: 0,
            filterFormModel: {},
            items: [],
            itemCount: 0,
            reloadTimer: null,
            listLoading: false,
            firstLoading: true,
            firstItemOfPage:0,
            lastItemOfPage:0
        }
    },
    methods: {
        load() {
            let loadingDelay = _.delay(() => {
                this.listLoading = true;
            }, 250);
            this.$service.get(this.service, {
                params: this.filterFormModel
            }).then(response => {
                this.firstLoading = false;
                this.apply(response.data);
            }).catch(error => {
                if (error.response.data.message) {
                    this.$swal({
                        text: error.response.data.message,
                        icon: 'error'
                    });
                }
            }).finally(() => {
                clearTimeout(loadingDelay);
                this.listLoading = false;
                if(this.afterLoad){
                    this.afterLoad();
                }
            });
        },
        apply(data) {
            this.items = data.docs;
            this.itemCount = data.totalDocs;
            this.firstItemOfPage = this.itemCount > 0 ? (this.filterFormModel.page - 1)  * this.filterFormModel.pageSize + 1 : 0;
            this.lastItemOfPage = (this.filterFormModel.page - 1)  * this.filterFormModel.pageSize + this.items.length;
        },
        reset() {
            this.filterFormModel = {};
            this.filterFormModel = Object.assign(this.filterFormModel, this.defaultFilterFormModel);
            this.load();
        },
    },
    mounted() {
        this.filterFormModel = Object.assign(this.filterFormModel, this.defaultFilterFormModel);
        if (this.autoLoad) {
            this.load();
            this.firstLoading = true;
        }
        if (this.reloadInterval > 0) {
            this.reloadTimer = setInterval(() => {
                this.$bgService.get(this.controller + '/' + this.actions.list, {
                    params: this.filterFormModel
                }).then(response => {
                    this.apply(response.data);
                });
            }, this.reloadInterval);
        }
        if (this.reloadBus) {
            this.$bus.$on(this.reloadBus, this.load);
        }
    },
    beforeDestroy() {
        if (this.reloadTimer != null) {
            clearInterval(this.reloadTimer);
        }
        if (this.reloadBus) {
            this.$bus.$off(this.reloadBus);
        }
    }
};
